import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TemplateRef } from '@angular/core';
import { BaseModel } from './base-model.model';
import { Estado } from './estado.model';

export class GrupoPerguntaEnergiaDTO extends BaseModel {

	public titulo: string;
	public subtitulo: string;
	public ordem: number;

	public frontTitulo: any;
	public frontSubtitulo: any;
}


export class OpcaoQuestionarioRespostaEnergiaDTO extends BaseModel {

    public texto: string;
	public valorConsumidorFinal: number;
	public valorEsco: number;
	public naoAplicavelConsumidorFinal: boolean;
	public negarCasoEsco: boolean;
	public negarCasoConsumidorFinal: boolean;
	public exigeTextoComplementar: boolean;
	public redFlag: boolean;
}


export class PerguntaEnergiaDTO extends BaseModel {
	public ordem: number;
	public tipoPergunta:TipoPerguntaEnum;
	public categoria: string;
	public textoPergunta: string;
	public tituloPergunta: string;
	public listaOpcoes: OpcaoQuestionarioRespostaEnergiaDTO[];
	public ativo: boolean;
	public disponivelSomenteEsco: boolean;
	public disponivelSomenteConsumidorFinal: boolean;
	public grupo: GrupoPerguntaEnergiaDTO;
	public tipoValor: TipoValorPerguntaEnum;
	public tipoCustomizacao: TipoCustomizacaoEnum;
	public tamanho: TamanhoPerguntaEnum;
	public respostaObrigatoria: boolean;

	public frontIsPerguntaNovoGrupo: boolean;
	public frontIsPerguntaNovaCategoria: boolean;
	public frontTemTextoComplementar: boolean;
	public frontMostrarTextoComplementar: boolean;
	public frontCustomTemplate: TemplateRef<any>;
	public frontRespostaAsText: string;
	public frontTitulo: any;
	public frontSubtitulo: any;
}

export class QuestionarioRespostaEnergiaDTO extends BaseModel {
	public idPergunta: number;
	public conteudo: string; //texto, id, lista de id's separados por ; ou atributos separados por ;
	public conteudoComplementar: string;
}


export class DadosClienteDTO {

	public isEmpresaTomadoraDiferente: boolean;

	public cnpjCliente: string;

	public nomeRepresentante: string;
	public cpfRepresentante: string;
	public emailRepresentante: string;
	public telefoneRepresentante: string;
	public relacaoRepresentante: string;

	public valorEstimadoProjeto: number;
    public cnpjBeneficiario: string;
    public razaoSocialBeneficiario: string;
    public cepBeneficiario: number;
    public logradouroBeneficiario: string;
    public complementoBeneficiario: string;
    public responsavelBeneficiario: string;
    public emailresponsavelBeneficiario: string;

}

export class QuestionarioAvaliacaoProjetoDTO extends BaseModel {
	public dadosCliente: DadosClienteDTO;
	public listaResposta: QuestionarioRespostaEnergiaDTO[] = [];
	public descricaoProjeto: string;

	public totalPontosLimiteProposta: number; // limite máximo de pontos para o aceite
	public totalPontosProposta: number;
	public ideRascunho: string;
	public token: string;
	public dataAprovacao: Date;
  	public estado: Estado;
	public textoJustificativa: string;

	// só permitiremos a persistencia do questionario (ou do seu rascunho) se houver um captcha valido
	public recaptchaResponseToken: string;
	public projetoEhMaisComplexo: boolean;
	public validarMaquinasEquipamentos: boolean;
}

export class ResponsavelAvaliacaoEconomiaDTO {
	public cnpj : string;
	public cpf: string;
    public nome: string;
	public profissao: string;
	public numeroRegistroProfissional: string;
	public orgaoRegistro: string;
	public unidadeFederacaoOrgao: string;
}

export class RetornoMensagemSimplesDTO {
	public mensagem: string;
}


export class MaquinasEquipamentosDTO {
    public codigoFiname : string;
	public nomeItem: string;
    public ordem: number; 
    public quantidade: number;
}

export class MenuQuestionarioModel extends BaseEntity {
	public cnpjRascunho: string;
	public numeroRascunho: string;
}

export enum TipoPerguntaEnum {
    ESCOLHA_UNICA = "ESCOLHA_UNICA",
	ESCOLHA_MULTIPLA = "ESCOLHA_MULTIPLA",
	LISTA_COM_REDFLAG = "LISTA_COM_REDFLAG",
	TEXTO_LIVRE = "TEXTO_LIVRE",
	PERSONALIZADA = "PERSONALIZADA"
}


export enum TipoValorPerguntaEnum {
	TEXTO = "TEXTO",
	NUMERO_INTEIRO = "NUMERO_INTEIRO",
	NUMERO_DECIMAL = "NUMERO_DECIMAL",
	DATA = "DATA",
	CNPJ = "CNPJ",
	CEP = "CEP"
}

export enum TamanhoPerguntaEnum {
	MUITO_PEQUENO = "MUITO_PEQUENO",
	PEQUENO = "PEQUENO",
	MEDIO = "MEDIO",
	GRANDE = "GRANDE"
}

export enum TipoCustomizacaoEnum {
	RESPONSAVEL_PELA_AVALIACAO = "RESPONSAVEL_PELA_AVALIACAO",
	TAXA_INTERNA_RETORNO = "TAXA_INTERNA_RETORNO",
	MAQUINAS_EQUIPAMENTOS = "MAQUINAS_EQUIPAMENTOS"
}

export const TIPO_FILTRAGEM_CAMPO = [

  {
    nome: 'CNPJ Cliente',
    numero: '1'

  },
  {
    nome: 'Data Aprovação',
    numero: '2'
  }
]

export const TIPO_ORDENACAO = [

  {
    nome: 'Ascendente',
    codigo: 'asc'

  },
  {
    nome: 'Descendente',
    codigo: 'desc'
  }
]

export enum EstadosEnum {
  NULO = null,
  AGUARDANDO_VALIDACAO = 1,
  DE_ACORDO = 2,
  NAO_DE_ACORDO = 3
}

export interface Estados {
  nome: string;
  valor: EstadosEnum;
}

export const EstadosLista: Estados[] = [
  {nome: 'Todos', valor: EstadosEnum.NULO},
  {nome: 'Aguardando validação', valor: EstadosEnum.AGUARDANDO_VALIDACAO},
  {nome: 'De acordo', valor: EstadosEnum.DE_ACORDO},
  {nome: 'Não de acordo', valor: EstadosEnum.NAO_DE_ACORDO}
];
